module.exports = __webpack_public_path__ + "img/sec02-chart.7588d2f2.gif";